import { create } from 'zustand';
import type { ModelEdition } from '../components/common/ModelVersionControl';
import type { FabricReferenceMode } from '../types';

interface FabricTryOnState {
  garmentFile: string | null;
  fabricFile: string | null;
  fabricReferenceMode: FabricReferenceMode;
  removeLogo: boolean;
  selectedAspectKey: string;
  selectedResolution: string;
  selectedModelEdition: ModelEdition;
  customPromptText: string;
  activeTaskIds: string[];
  setGarmentFile: (path: string | null) => void;
  setFabricFile: (path: string | null) => void;
  setFabricReferenceMode: (mode: FabricReferenceMode) => void;
  setRemoveLogo: (remove: boolean) => void;
  setSelectedAspectKey: (key: string) => void;
  setSelectedResolution: (resolution: string) => void;
  setSelectedModelEdition: (edition: ModelEdition) => void;
  setCustomPromptText: (text: string) => void;
  setActiveTaskIds: (ids: string[] | ((current: string[]) => string[])) => void;
  reset: () => void;
}

const initialState = {
  garmentFile: null,
  fabricFile: null,
  fabricReferenceMode: 'texture' as FabricReferenceMode,
  removeLogo: false,
  selectedAspectKey: '1:1',
  selectedResolution: '1K',
  selectedModelEdition: 'auto' as ModelEdition,
  customPromptText: '',
  activeTaskIds: [] as string[],
};

export const useFabricTryOnStore = create<FabricTryOnState>((set) => ({
  ...initialState,
  setGarmentFile: (garmentFile) => set({ garmentFile }),
  setFabricFile: (fabricFile) => set({ fabricFile }),
  setFabricReferenceMode: (fabricReferenceMode) => set({ fabricReferenceMode }),
  setRemoveLogo: (removeLogo) => set({ removeLogo }),
  setSelectedAspectKey: (selectedAspectKey) => set({ selectedAspectKey }),
  setSelectedResolution: (selectedResolution) => set({ selectedResolution }),
  setSelectedModelEdition: (selectedModelEdition) => set({ selectedModelEdition }),
  setCustomPromptText: (customPromptText) => set({ customPromptText }),
  setActiveTaskIds: (ids) => set((state) => ({
    activeTaskIds: typeof ids === 'function' ? ids(state.activeTaskIds) : ids,
  })),
  reset: () => set({ ...initialState }),
}));
